<div>
	<div *ngIf="overviewVm$ | async">
        @if (
            overviewVm?.overview?.length > 0 
            && !isMobile
        ) {
            <div>
                @for (event of overviewVm.overview; track event;) {
                    <div>
                        <pcg-emergency-event-banner-card [model]="event"></pcg-emergency-event-banner-card>
                        <div class="flex-parent">
                            @for (site of event.siteStats; track site;) {
                                <div class="flex-child">
                                    <pcg-site-detail-card [model]="site"></pcg-site-detail-card>
                                </div>
                            }
                        </div>
                    </div>
                }                
            </div>
        }
	</div>
    @if (isMobile) {
        <div class="space-top d-flex flex-column justify-content-center align-items-center">
            <div class="bg-light w-100 rounded p-3">
                @if (!isNoTeamAssociation) {
                    <div>
                        <div>
                            <h5 class="h5-custom"><u>Team Name:</u></h5>
                            <div class="bigger-text">{{ teamName }}</div>
                        </div>
                        <div>
                            <h5 class="h5-custom mt-2"><u>Emergency Event:</u></h5>
                            <div class="bigger-text">{{ emergencyEvent }}</div>
                        </div>
                        <div>
                            <h5 class="h5-custom mt-2"><u>Tank Asset Number(s):</u></h5>
                            @for (tankAssetNumber of tankAssetNumbers; track tankAssetNumber;) {
                                <div class="bigger-text">{{ tankAssetNumber }}</div>
                            }
                        </div>
                    </div>
                } @else {
                    <div>
                        <div class="text-center">
                            <h5><u>You are not associated to a team</u></h5>
                            <div>Contact your administrator for your team association.</div>
                        </div>
                    </div>
                }
            </div>
            @if (!isNoTeamAssociation) {
                <button 
                    class="btn btn-save btn-lg mt-4" 
                    (click)="goToDispense()"
                >Dispense</button>
            }
        </div>
    }	
</div>